var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessenger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 39,
    viewBox: "0 0 38 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 18.5707C38 28.8275 29.4975 37.1414 19 37.1414C17.4315 37.1414 15.9125 36.9567 14.4552 36.6043C14.0134 36.4976 13.5517 36.5386 13.1451 36.7424L8.987 38.8271C7.9135 39.3652 6.65 38.5823 6.65 37.3786V33.5454C6.65 32.9978 6.40585 32.4873 6.00305 32.1178C2.30375 28.7275 0 23.9134 0 18.5707C0 8.31397 8.5025 0 19 0C29.4975 0 38 8.31397 38 18.5707Z",
    fill: "url(#paint0_radial_17861_265350)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M29.146 13C28.7509 13 28.3678 13.1272 28.0383 13.3683L22.782 17.1452C22.6592 17.2348 22.5235 17.2796 22.3805 17.2796C22.242 17.2796 22.1118 17.2375 22.002 17.1577L18.3354 14.4785C17.5895 13.94 16.7107 13.6559 15.7903 13.6559C14.3355 13.6559 12.9979 14.3647 12.2123 15.552L11.0944 17.2464L7.29116 23.2455C6.9293 23.7957 6.90161 24.4749 7.22562 25.0502C7.5561 25.6362 8.18013 26 8.854 26C9.2491 26 9.63219 25.8728 9.96174 25.6317L15.218 21.8548C15.3408 21.7652 15.4765 21.7204 15.6195 21.7204C15.758 21.7204 15.8882 21.7625 15.998 21.8423L19.6646 24.5215C20.4114 25.0609 21.2893 25.3441 22.2097 25.3441C23.6645 25.3441 25.0021 24.6353 25.7877 23.448L26.9056 21.7536L30.7088 15.7545C31.0707 15.2043 31.0984 14.5251 30.7744 13.9498C30.4439 13.3638 29.8199 13 29.146 13Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M29.5532 13C29.2469 13 28.9483 13.103 28.69 13.2983L23.2197 17.3574C23.0123 17.5142 22.7703 17.596 22.5168 17.596C22.2681 17.596 22.0328 17.5171 21.835 17.3689L18.0201 14.4906C17.3297 13.9758 16.5145 13.7044 15.6609 13.7044C14.3118 13.7044 13.0721 14.3829 12.3433 15.5203L11.1815 17.3401L7.23019 23.7761C6.945 24.2236 6.92292 24.7702 7.17449 25.2301C7.42991 25.6978 7.93018 26 8.44678 26C8.75308 26 9.05171 25.897 9.31001 25.7017L14.7803 21.6426C14.9877 21.4858 15.2297 21.404 15.4832 21.404C15.7319 21.404 15.9672 21.4829 16.165 21.6311L19.9799 24.5094C20.6703 25.0242 21.4855 25.2956 22.3391 25.2956C23.6882 25.2956 24.9279 24.6171 25.6567 23.4797L26.8185 21.6599L30.7698 15.2239C31.055 14.7764 31.0771 14.2298 30.8255 13.7699C30.5701 13.3022 30.0708 13 29.5532 13Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5274 14.1842L23.3016 17.8955C22.7424 18.3 21.9814 18.3 21.4313 17.9043L17.788 15.2739C16.2478 14.1746 14.0658 14.5527 13.0298 16.1005L11.9205 17.7627L8.15246 23.6373C7.60238 24.464 8.65669 25.405 9.47264 24.8158L14.6984 21.1045C15.2576 20.7 16.0186 20.7 16.5687 21.0957L20.212 23.7261C21.7522 24.8254 23.9342 24.4473 24.9702 22.8995L26.0795 21.2373L29.8475 15.3627C30.3976 14.536 29.3433 13.595 28.5274 14.1842Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_17861_265350",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.73265 37.1205) scale(45.2314 45.343)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1292FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.079,
    stopColor: "#2982FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#4E69FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351,
    stopColor: "#6559FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.428,
    stopColor: "#6D53FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.754,
    stopColor: "#DF47AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.946,
    stopColor: "#FF6257"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessenger);
export default __webpack_public_path__ + "static/media/messenger.a4e18f03a9b25069a7c7ddfcd7fffdc0.svg";
export { ForwardRef as ReactComponent };